import api from "@/api";
import BatterTableDataView from "@/components/BatterTableDataView.vue";
import DialogCustomView from "@/components/DialogCustomView.vue";
import { ElMessage } from "element-plus";
export default {
  name: "SchoolListView",
  components: {
    DialogCustomView,
    BatterTableDataView
  },
  data() {
    return {
      tab: '-',
      sites: [],
      addPageVisible: false,
      siteId: null,
      schoolId: null
    };
  },
  methods: {
    previewHtml(d) {
      window.open(`/html/preview/${d.htmlId}?footer=${d.footId ? d.footId : ''}&page=${d.id}`, '_blank');
    },
    goToEditSchoolContent(d) {
      window.open('/html/edit/' + d.contentId, '_blank');
    },
    choose(pid) {
      api.updateSchoolRecommendPage({
        pageId: pid,
        schoolId: this.schoolId
      }).then(() => {
        ElMessage.success("操作成功");
        this.addPageVisible = false;
        for (let s of this.$refs.schools) {
          s.fetchData();
        }
      });
    },
    addPage(schoolId, siteId) {
      this.siteId = siteId;
      this.schoolId = schoolId;
      this.addPageVisible = true;
    },
    init() {
      api.getEnumOptionList(4, true).then(ret => {
        this.sites = ret;
        this.tab = ret.length > 0 ? ret[0].label : '-';
      });
    }
  },
  mounted() {
    this.init();
  }
};